
/**
 * Search Model for searching backlogs of quote
 */
class BacklogSearchModel {
    /**
     * @param {[string]} getParams
     * @param {[string]} hasParams
     * @param {[string]} noHasParams
     */
    constructor(getParams=[], hasParams=[], noHasParams=[]) {
        this.get_params = getParams
        this.has_params = hasParams
        this.no_has_params = noHasParams
    }

    /**
     * @param {json} json
     * @return {BacklogSearchModel}
     */
    static from(json) {
        return Object.assign(new BacklogSearchModel(), json)
    }
}

module.exports = {
    BacklogSearchModel,
}
